import { Box } from '@factorialco/deprecated-design-system'
import {
  AtsGetApplicationsGenderInsightsDocument,
  AtsInsightsMetricsFilterFragment,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ApplicationsGenderChart } from 'modules/ats/components/Insights/ApplicationsGenderChart'
import { DataNotAvailable } from 'modules/ats/components/Insights/DataNotAvailable'
import { LastUpdatedAt } from 'modules/ats/components/Insights/LastUpdatedAt'
import { MetricsFilters } from 'modules/ats/pages/InsightsPage/MetricsFilters'
import { useMetricsFilters } from 'modules/ats/pages/InsightsPage/MetricsFiltersProvider'

// We started saving gender data from this date.
// We don't want to show data before that month because the results would be filled with "Not asked"
const PARITY_INSIGHTS_MINIMUM_DATE = '2023-06-01'

interface Props {
  atsCompanyId: string
  jobs: AtsInsightsMetricsFilterFragment[]
}

export const ParityMetrics = ({ atsCompanyId, jobs }: Props) => {
  const { filters } = useMetricsFilters()
  const { data, error } = useQuery(AtsGetApplicationsGenderInsightsDocument, {
    variables: { ...filters, atsCompanyId },
  })

  const incorrectDateRange =
    filters.startDateRange !== undefined && filters.startDateRange < PARITY_INSIGHTS_MINIMUM_DATE

  useEffect(() => {
    track(trackingEvents.ats.insightsGenderView)
  }, [])

  const lastUpdatedAts = data?.ats.lastUpdatedAtInsightsConnection.nodes
  return (
    <Box paddingY="s24" gap="s24">
      <Box flexDirection="row" gap="s16">
        <MetricsFilters jobs={jobs} />
        <LastUpdatedAt lastUpdatedAts={lastUpdatedAts} id={'applications'} />
      </Box>
      {error?.message ? (
        <Box minHeight="s240" justifyContent="center">
          <DataNotAvailable />
        </Box>
      ) : (
        <ApplicationsGenderChart
          applicationsGenderData={data?.ats.applicationsGenderInsightsConnection.nodes || []}
          alert={
            incorrectDateRange
              ? i18n.t('ats.insights_page.parity_breakdown_metrics.date_filter_alert')
              : undefined
          }
        />
      )}
    </Box>
  )
}
